var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',_vm._g({staticClass:"app-image",class:_vm.size},_vm.$listeners),[_c('img',{staticClass:"app-image__image",attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }